export enum DataPackageStatusEnum {
    Draft = 'Draft',
    Submitted = 'Submitted',
}
